module.exports = __webpack_public_path__ + "static/media/giftest.8556dcf6.gif";